export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const SYNC_USER = 'SYNC_USER';
export const LOGOUT = 'LOGOUT';


// Opening Auth Modal
export const OPEN_AUTH_MODAL = 'OPEN_AUTH_MODAL'
export const CLOSE_AUTH_MODAL = 'CLOSE_AUTH_MODAL'
export const OPEN_UPDATE_PROFILE_MODAL = 'OPEN_UPDATE_PROFILE_MODAL'
export const CLOSE_UPDATE_PROFILE_MODAL = 'CLOSE_UPDATE_PROFILE_MODAL'
export const OPEN_BULK_ORDER_MODAL = 'OPEN_BULK_ORDER_MODAL'
export const CLOSE_BULK_ORDER_MODAL = 'CLOSE_BULK_ORDER_MODAL'


export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const LOAD_MENU = 'LOAD_MENU';

export const ADD_TO_CART = "ADD_TO_CART";
export const CART_LOADING = 'CART_LOADING';
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";

export const ADD_TO_FAVORITES = "ADD_TO_FAVORITES"
export const REMOVE_FROM_FAVORITES = "REMOVE_FROM_FAVORITES"

export const ADD_ADDRESS = "ADD_ADDRESS"
export const REMOVE_ADDRESS = "REMOVE_ADDRESS"

export const SET_HISTORY = "SET_HISTORY"
export const SET_DELIVERY_LOCATION = "SET_DELIVERY_LOCATION"
export const SET_NEAREST_OUTLET = "SET_NEAREST_OUTLET"


export const LOAD_OUTLETS = "LOAD_OUTLETS"
export const LOAD_PROMO_CODES = "LOAD_PROMO_CODES"

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT'
export const SET_FOOD_PREFRENCE = 'SET_FOOD_PREFRENCE'

export const LOAD_USER_ORDERS = 'LOAD_USER_ORDERS'
export const CREATE_ORDER = 'CREATE_ORDER'


